import Alpine from 'alpinejs';
export var videoBehavior = function videoBehavior() {
  Alpine.data('videoBehavior', function () {
    return {
      init: function init() {
        var video = this.$el;
        var videoButton = video.querySelector('.a-video__button');

        // Todo: Review the following iframe lazy load logic. Causing issues with CSP.
        // When a play button is clicked:
        // 1) Copy the data-src attribute to the src attribute
        // 2) Delete the data-src attribute
        // 3) Detach the button from the DOM
        videoButton.addEventListener('click', function (event) {
          var iframe = video.querySelector('iframe');
          var src = iframe.getAttribute('data-src');
          iframe.removeAttribute('data-src');
          iframe.setAttribute('src', src);
          this.parentNode.removeChild(this);
        });
      }
    };
  });
};